import { Component, Input, Output, EventEmitter, HostListener, HostBinding } from '@angular/core';
export var LogMonitorButtonComponent = (function () {
    function LogMonitorButtonComponent() {
        this.action = new EventEmitter();
    }
    LogMonitorButtonComponent.prototype.handleAction = function ($event) {
        if (!this.disabled) {
            this.action.next({});
        }
        $event.stopPropagation();
        return false;
    };
    LogMonitorButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'log-monitor-button',
                    template: "\n    <ng-content></ng-content>\n  ",
                    styles: ["\n    :host{\n      flex-grow: 1;\n      display: inline-block;\n      font-family: 'monaco', 'Consolas', 'Lucida Console', monospace;\n      cursor: pointer;\n      font-weight: bold;\n      border-radius: 3px;\n      padding: 4px 8px;\n      margin: 5px 3px 5px 3px;\n      font-size: 0.8em;\n      color: white;\n      text-decoration: none;\n      background-color: #4F5A65;\n    }\n\n    :host.disabled{\n      opacity: 0.2;\n      cursor: text;\n      background-color: transparent;\n    }\n  "]
                },] },
    ];
    /** @nocollapse */
    LogMonitorButtonComponent.ctorParameters = [];
    LogMonitorButtonComponent.propDecorators = {
        'disabled': [{ type: HostBinding, args: ['class.disabled',] }, { type: Input },],
        'action': [{ type: Output },],
        'handleAction': [{ type: HostListener, args: ['click', ['$event'],] },],
    };
    return LogMonitorButtonComponent;
}());
//# sourceMappingURL=log-monitor-button.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngrx/store-log-monitor/src/log-monitor/log-monitor-button.js
// module id = HbHJ
// module chunks = 4